import { memo, FC } from 'react';
import { Col, Row } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { ColorValues, Tab } from 'Types';
import { Card, DecorationTab, FontAwesome } from 'Elements';

export const IntegrationAppDecorationBox: FC = memo(() => {
	const { pathname } = useLocation();
	const defaultTab =
		pathname === '/integration' || pathname === '/integration/linkedin';

	const tabs: Tab[] = [
		{
			id: 0,
			title: 'tab.linkedin',
			path: 'linkedin',
			isActive: defaultTab
		}
	];

	return (
		<Card tab>
			<div className="d-flex align-items-center gap-4 mb-4">
				<FontAwesome
					icon="grid-2"
					size="6x"
					className="flex-shrink-0"
					color={ColorValues.primary}
				/>
				<Row className="flex-grow-1">
					<Col md={7} lg={6} xxl={9}>
						<h3 className="h5 lh-sm fw-400">
							Social App Integration Hub
						</h3>
						<p className="text-gray-3 lh-base mb-0 fw-300 fs-sm">
							Connect Your Social Networks to Improve Your App
							Experience: Easily link your social accounts to
							access extra features and personalized interactions.
							Share, connect, and engage conveniently, all within
							one app.
						</p>
					</Col>
				</Row>
			</div>
			<DecorationTab tabs={tabs} />
		</Card>
	);
});

IntegrationAppDecorationBox.displayName = 'IntegrationAppDecorationBox';
